var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteCol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#68688a",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.343266 935.71214a299.089969 299.089969 0 0 0 48.89545 74.239165A213.330933 213.330933 0 0 1 298.663307 810.657547V213.330933a213.330933 213.330933 0 1 1 426.661866 0v311.036501a297.468653 297.468653 0 0 0-85.332373 41.17287V213.330933a127.99856 127.99856 0 0 0-255.99712 0v597.326614a127.99856 127.99856 0 0 0 155.347586 125.054593zM810.657547 597.326613a213.330933 213.330933 0 1 1 0 426.661867 213.330933 213.330933 0 0 1 0-426.661867z m-106.665467 253.351817h213.330933a39.978217 39.978217 0 1 0 0-79.9991h-213.330933a39.978217 39.978217 0 1 0 0 79.9991z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCol);
export default __webpack_public_path__ + "static/media/delete_col.a9882560b0348bb6554927cdce8e4308.svg";
export { ForwardRef as ReactComponent };